import React from "react";
import { ReactComponent as Logo } from '../assets/logo.svg';
import { FaFacebook, FaInstagram, FaWhatsapp, FaLinkedin } from "react-icons/fa";

const Footer = () => {
	const redes = [
		{ icon: FaWhatsapp, url: "https://api.whatsapp.com/send/?phone=522224292114&text&type=phone_number&app_absent=0" },
		{ icon: FaFacebook, url: "https://www.facebook.com/profile.php?id=100069422446802#" },
		{ icon: FaInstagram, url: "https://www.instagram.com/nemesissc7/" },
		{ icon: FaLinkedin, url: "https://www.linkedin.com/in/dist-empresarial-nemesis-262196214/" },
	];

	return (
		<footer className="h-fit w-full grid grid-cols-1 p-4 bg-purple-900 shadow text-white">
			<div className="grid grid-cols-2 md:grid-cols-3">
				<div className="w-full flex justify-center items-center">
					<Logo className="w-44"/>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> Horarios: 10:00 AM - 7:00 PM </h2>
					<p> (52) (52) 22 11 03 29 05 </p>
					<p> consupres@outlook.com </p>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> Dirección </h2>
					<p>
						{" "}
							Calle 51 Poniente, 1110
							INT. 1A, Prados Agua Azul
							Puebla, Pue. México
							Código Postal: 72430
						{" "}
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
